import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useActiveSpectrumIntegralsViewState } from '../../hooks/useActiveSpectrumIntegralsViewState';
import useIntegralPath from '../../hooks/useIntegralPath';
import { usePanelPreferences } from '../../hooks/usePanelPreferences';
import IntegralResizable from './IntegralResizable';
export function Integration(props) {
    const { integral, nucleus, max, from, to } = props;
    const { x, y } = integral;
    const { scaleRatio } = useActiveSpectrumIntegralsViewState();
    const path = useIntegralPath({ x, y, max, scaleRatio, from, to });
    const { showIntegralsValues } = useActiveSpectrumIntegralsViewState();
    const integralPreferences = usePanelPreferences('integrals', nucleus);
    return (_jsxs("g", { children: [_jsx("path", { className: "line", stroke: integralPreferences.color, strokeWidth: integralPreferences.strokeWidth, fill: "none", d: path }), showIntegralsValues && (_jsx(IntegralResizable, { integralData: integral, integralFormat: integralPreferences.relative.format }))] }));
}
